"use strict";
var Observable_1 = require("../../Observable");
var zipAll_1 = require("../../operator/zipAll");
Observable_1.Observable.prototype.zipAll = zipAll_1.zipAll;
//# sourceMappingURL=zipAll.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/zipAll.js
 ** module id = 446
 ** module chunks = 1
 **/